import type { CurrencyCode } from '~/schemas/shopify/admin.types';

export const ACTIVE_TABS_ANALYTIC_MAPPING: Record<
  number,
  'totalRevenueInUsd' | 'totalOrders' | 'conversionRate' | 'aov' | 'aovIncrease'
> = {
  0: 'totalOrders',
  1: 'conversionRate',
  2: 'totalRevenueInUsd',
  3: 'aov',
  6: 'aovIncrease',
};

export const ACTIVE_TABS_ANALYTIC_REVERSE_MAPPING = Object.fromEntries(
  Object.entries(ACTIVE_TABS_ANALYTIC_MAPPING).map(([key, value]) => [value, Number(key)]),
);

export const DEFAULT_CURRENCY_ANALYTIC = 'USD' as CurrencyCode;
